import axios from 'axios';
import {SETTINGS} from "@/app/constants/settings";
import {
    checkBaseRequest,
    checkRequest, checkRequestBase, checkRequestSpace,
    errorResult,
    fileDownloadResult,
    result
} from "@services/dataSource/lib/axiosInterceptor";
import qs from 'qs';

export const apiClient = axios.create({
  baseURL: SETTINGS.BASE_URL, // 기본 서버 주소 입력
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    // "X-SQI-KEY": "SQISOFT74307!"
  },
  paramsSerializer: params => {
    return qs.stringify(params, { arrayFormat: 'repeat' });
    // return qs.stringify(params);
  }
});

export const apiBaseClient = axios.create({
  baseURL: SETTINGS.BASE_URL, // 기본 서버 주소 입력
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    // "X-SQI-KEY": "SQISOFT74307!"
  },
  paramsSerializer: params => {
    return qs.stringify(params, { arrayFormat: 'repeat' });
    // return qs.stringify(params)
  }
});

export const apiSpaceClient = axios.create({
    baseURL: SETTINGS.BASE_URL, // 기본 서버 주소 입력
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        // "X-SQI-KEY": "SQISOFT74307!"
    },
    paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
        // return qs.stringify(params)
    }
});

export const apiFileClient = axios.create({
  baseURL: SETTINGS.BASE_URL, // 기본 서버 주소 입력
  headers: {
    Accept: "application/json",
    "Content-Type": "multipart/form-data",
    // "X-SQI-KEY": "SQISOFT74307!"
  },
  paramsSerializer: params => {
    return qs.stringify(params, { arrayFormat: 'repeat' });
    // return qs.stringify(params)
  }
});

export const apiFileDownloadClient = axios.create({
  baseURL: SETTINGS.BASE_URL, // 기본 서버 주소 입력
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    // "X-SQI-KEY": "SQISOFT74307!"
  },
  responseType: 'blob',
  timeoutErrorMessage: 'EXCEL_DOWNLOAD_TIMEOUT',
  paramsSerializer: params => {
    return qs.stringify(params, { arrayFormat: 'repeat' });
    // return qs.stringify(params)
  },
});

// onUploadProgress(storage, evt.loaded, evt.total, i, fileId);

// axios.defaults.withCredentials = true;
apiClient.interceptors.request.use(checkRequest);
apiClient.interceptors.response.use(result, errorResult);
apiBaseClient.interceptors.request.use(checkRequestBase); //base url
apiBaseClient.interceptors.response.use(result, errorResult); //base url
apiSpaceClient.interceptors.request.use(checkRequestSpace); //space url (mercury, venus, ...)
apiSpaceClient.interceptors.response.use(result, errorResult); //space url (mercury, venus, ...)
apiFileClient.interceptors.request.use(checkRequest);
apiFileClient.interceptors.response.use(result, errorResult);
apiFileDownloadClient.interceptors.request.use(checkRequest);
apiFileDownloadClient.interceptors.response.use(fileDownloadResult, errorResult);
